/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 * @param {string|React.ReactNode} content - Tooltip content, can be text or a React node.
 * @param {function} t - Translation function for internationalization.
 * @returns {React.ReactNode|null} - JSX element with formatted content or null if no content.
 */
const renderTooltipContent = (content, t) => {
  if (!content) return null;
 
  if (typeof content === 'string') {
    const lines = t(content).toUpperCase().split('\n');
    const moreThan = lines.length > 9;
    const onlyOne = lines.length === 1;
    return (
      <div className='tooltip-preline'>
        {lines.map((line, index) => {
          const isLast = index === lines.length - 1;

          if (isLast && moreThan) {
            return (
              <div key={index} className='text text-end ibl-font-w-700'>
                {line}
              </div>
            );
          }
          return (
            <div key={index}>
              {!onlyOne && `• `}
              {line}
            </div>
          );
        })}
      </div>
    );
  }
  return content;
};

export default renderTooltipContent